module.exports = __webpack_public_path__ + "static/media/outerwear.338869ae.jpg";